
import { motion } from 'framer-motion';

export function Awards() {
  const awards = [
    {
      year: '2024',
      title: '매경 살기좋은 아파트 선발 대회',
      award: '우수상 수상'
    },
    {
      year: '2025',
      title: '한경 주거문화대상',
      award: '브랜드 대상 수상'
    },
    {
      year: '2020',
      title: '매경 살기좋은 아파트 선발 대회',
      award: '종합대상 수상'
    }
  ];

  const rankings = [
    { rank: 8, brand: 'DL e편한세상' },
    { rank: 9, brand: 'SK VIEW' },
    { rank: 10, brand: '우미 린', highlight: true },
    { rank: 11, brand: '호반 써밋' }
  ];

  return (
    <section id="awards" className="py-12 sm:py-16 md:py-24 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 sm:mb-12 md:mb-16"
        >
          <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4">
            <div className="w-2 h-2 bg-amber-600 rounded-full"></div>
            <p className="text-amber-600 text-xs sm:text-sm font-semibold tracking-wider uppercase">
              PREMIUM BRAND
            </p>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight px-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            공신력 있는 언론사가 인정한<br />
            고객감동의 프리미엄 브랜드, 우미 린
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600">
            공간의 가치로 공감을 채우는 아파트
          </p>
        </motion.div>

        {/* Awards Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 mb-8 sm:mb-12 md:mb-16">
          {awards.map((award, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="text-4xl sm:text-5xl md:text-6xl font-bold text-amber-600 mb-4 sm:mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
                {award.year}
              </div>
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-trophy-line text-4xl sm:text-5xl text-amber-600"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">
                {award.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                {award.award}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Additional Brand Image */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-6 sm:mb-8"
        >
          <div className="relative w-full h-[300px] sm:h-[450px] md:h-[600px] lg:h-[750px] rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl">
            <img
              src="https://static.readdy.ai/image/9acf540dec95fde23784f4db934ca461/2cdfd447fdea0d7534491cd76c50a1d3.png"
              alt="우미 린 프리미엄 단지 전경"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </motion.div>

        {/* Rankings Table */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mx-auto bg-white/80 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 shadow-lg mb-6 sm:mb-8"
        >
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6 text-center">
            베스트 아파트 브랜드 순위<br />
            <span className="text-amber-600">3년 연속 Top 10!</span>
          </h3>
          <div className="space-y-2 sm:space-y-3">
            {rankings.map((item) => (
              <div
                key={item.rank}
                className={`flex items-center justify-between p-3 sm:p-4 rounded-xl transition-all ${
                  item.highlight
                    ? 'bg-amber-600 text-white shadow-md'
                    : 'bg-gray-50 text-gray-900'
                }`}
              >
                <span className="text-xl sm:text-2xl font-bold w-10 sm:w-12">{item.rank}</span>
                <span className="text-base sm:text-lg font-semibold flex-1 text-center">
                  {item.brand}
                </span>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Brand Image */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-8 sm:mb-12 md:mb-16"
        >
          <div className="relative w-full h-[300px] sm:h-[500px] md:h-[650px] lg:h-[800px] rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl">
            <img
              src="https://static.readdy.ai/image/9acf540dec95fde23784f4db934ca461/1cd89efcd0db54eb1bc6a18bc63e9989.png"
              alt="우미 린 프리미엄 브랜드 이미지"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute bottom-4 sm:bottom-6 md:bottom-8 left-4 sm:left-6 md:left-8 text-white">
              <p className="text-xs sm:text-sm font-medium tracking-wider uppercase mb-1 sm:mb-2">WOOMI LIN</p>
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
                프리미엄 주거의 새로운 기준
              </h3>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
